<!--
 * @Author: your name
 * @Date: 2020-07-24 11:59:05
 * @LastEditTime: 2020-07-24 14:57:07
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /xdap-h5/src/pages/test/test.vue
-->
<template>
  <div class="test">
    <list-card></list-card>
  </div>
</template>

<script>
import ListCard from '@/components/list-card/list-card.vue'

export default {
  components: {
    ListCard
  }
}
</script>

<style lang="scss">

</style>
